/* ===== Wellrite motion + interaction layer ===== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- 1. Scroll reveal ---------------- */
  function initReveal() {
    var els = document.querySelectorAll('.wr [data-rv]');
    if (!els.length) return;

    function showAll() {
      for (var i = 0; i < els.length; i++) els[i].classList.add('rv-in');
    }
    if (REDUCED || !('IntersectionObserver' in window)) return showAll();

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('rv-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
    );
    for (var i = 0; i < els.length; i++) io.observe(els[i]);

    /* failsafe: never leave content invisible */
    setTimeout(showAll, 4000);
  }

  /* ---------------- 2. Scroll progress bar ---------------- */
  function initProgress() {
    if (REDUCED) return;
    var bar = document.createElement('div');
    bar.className = 'wr-progress';
    document.body.appendChild(bar);

    var ticking = false;
    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? window.scrollY / max : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)) + ')';
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  /* ---------------- 3. Back to top ---------------- */
  function initBackToTop() {
    var btn = document.createElement('button');
    btn.className = 'wr-top';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 19V5"/><path d="m5 12 7-7 7 7"/></svg>';
    document.body.appendChild(btn);

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
    });

    var ticking = false;
    function update() {
      btn.classList.toggle('show', window.scrollY > 700);
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  /* ---------------- 4. Toast ---------------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(message, linkText, linkHref) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wr-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    var html =
      '<span class="tick"><svg viewBox="0 0 24 24"><path d="m5 12 4 4 10-10"/></svg></span><span>' +
      message +
      '</span>';
    if (linkText) html += '<a href="' + linkHref + '">' + linkText + '</a>';
    toastEl.innerHTML = html;

    // force reflow so the transition replays
    void toastEl.offsetWidth;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('show');
    }, 4200);
  }

  /* ---------------- 5. AJAX add to cart ---------------- */
  function refreshCartBubble() {
    var host = document.getElementById('cart-icon-bubble');
    if (!host) return;
    fetch('/cart?section_id=cart-icon-bubble')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-icon-bubble');
        if (!fresh) return;
        host.innerHTML = fresh.innerHTML;
        if (!REDUCED) {
          host.classList.remove('wr-bump');
          void host.offsetWidth;
          host.classList.add('wr-bump');
        }
      })
      .catch(function () {});
  }

  function initAjaxCart() {
    var forms = document.querySelectorAll('.wr .prods form.qa');
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', function (ev) {
        var form = ev.currentTarget;
        var btn = form.querySelector('button.add');
        if (!btn) return; // let the browser handle it normally

        ev.preventDefault();
        var label = btn.textContent;
        btn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            return r.json().then(function (data) {
              return { ok: r.ok, data: data };
            });
          })
          .then(function (res) {
            btn.classList.remove('is-loading');
            if (!res.ok) {
              // e.g. out of stock — fall back to the normal form post
              btn.textContent = label;
              form.submit();
              return;
            }
            btn.classList.add('is-done');
            btn.textContent = 'Added ✓';
            refreshCartBubble();
            toast('Added to your cart', 'View cart →', '/cart');
            setTimeout(function () {
              btn.classList.remove('is-done');
              btn.textContent = label;
            }, 2200);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.textContent = label;
            form.submit(); // network hiccup: use the plain form
          });
      });
    }
  }

  /* ---------------- 6. Smooth anchor scroll ---------------- */
  function initAnchors() {
    var links = document.querySelectorAll('.wr a[href^="#"]');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function (ev) {
        var id = ev.currentTarget.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        ev.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({ top: top, behavior: REDUCED ? 'auto' : 'smooth' });
      });
    }
  }

  function boot() {
    initReveal();
    initProgress();
    initBackToTop();
    initAjaxCart();
    initAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
